export default __webpack_public_path__ + "static/media/sidebar-0.c6bf0d64.jpg";